import React from 'react';
import { Spin } from 'antd';
import FadeIn from '../FadeIn';

export default function LoadingScreen() {
  return (
    <FadeIn className="h-screen w-full flex items-center justify-center">
      <Spin size="large" />
    </FadeIn>
  );
}
